export default {
  originCity: 'Seleccionar ciudad de origen',
  destinationCity: 'Seleccionar ciudad de llegada',
  direct: 'Directo',
  indirect: '1 escala o más',
  getPrices: 'Compara precios',
  directAvailable: 'Vuelo directo disponible desde',
}
